import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../../commons/Header';
import { ReactComponent as IconBuilding } from '../../../../images/icn_buildings.svg';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { ContFilterYear } from '../../../../styled-components';
import generateYearOptions from '../../../../lib/helpers/generateYearOptions';
import GiveTable from './GiveTable';
import TakeTable from './TakeTable';
import CommercialTable from './CommercialTable';

const GiveAndTakeSupplierPresentational = ({
  data,
  onFilter,
  profile,
  query,
  total,
}) => {
  const [t] = useTranslation('GIVE_AND_TAKE');

  const { year } = query;

  return (
    <TabContent activeTab={'1'}>
      <TabPane tabId="1">
        <section style={{ marginBottom: '20px' }}>
          <Header
            title={t('PAGES:GIVE_AND_TAKE')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <TabContent activeTab={'1'}>
            <TabPane tabId="1">
              <Row
                className="search-add-cont m-t-20"
                style={{ rowGap: '1rem', marginBottom: '1rem' }}
              >
                <Col sm="12" md="6" lg="3" className="select-wrapper">
                  <ContFilterYear
                    className="no-width"
                    style={{ marginBottom: '0' }}
                  >
                    <Row>
                      <Col xs="6">
                        <Label>{t('SEARCH_BY_YEAR')}</Label>
                      </Col>
                      <Col xs="6">
                        <FormGroup>
                          <CustomInput
                            type="select"
                            id="selectYear"
                            name="year"
                            value={query && query.year}
                            onChange={({ target: { value: year } }) => {
                              onFilter({ year });
                            }}
                          >
                            {generateYearOptions()}
                          </CustomInput>
                        </FormGroup>
                      </Col>
                    </Row>
                  </ContFilterYear>
                </Col>
              </Row>

              {profile &&
                [
                  'BUILDING_ADMIN_1',
                  'BUILDING_ADMIN_2',
                  'BUILDING_ADMIN_3',
                  'BUILDING_ADMIN_4',
                  'BUILDING_ADMIN_5',
                  'AGENCY',
                  'COMMERCIAL',
                ].includes(profile.type) && (
                  <GiveTable data={data} total={total} onFilter={onFilter} />
                )}

              {profile &&
                [
                  'SUPPLIER',
                  'EON_ENERGY',
                  'BUILDING_ADMIN_1',
                  'BUILDING_ADMIN_2',
                  'BUILDING_ADMIN_3',
                  'BUILDING_ADMIN_4',
                  'BUILDING_ADMIN_5',
                ].includes(profile.type) && (
                  <TakeTable
                    data={data}
                    total={total}
                    onFilter={onFilter}
                    profile={profile}
                  />
                )}

              {profile &&
                (profile.type === 'COMMERCIAL' ||
                  profile.commercial === true) && (
                  <CommercialTable
                    data={data}
                    total={total}
                    onFilter={onFilter}
                  />
                )}
            </TabPane>
          </TabContent>
        </section>
      </TabPane>
    </TabContent>
  );
};

export default GiveAndTakeSupplierPresentational;
